import { IDynamicPaperTutorialState } from '@/types/redux'
import { createDraftSafeSelector } from '@reduxjs/toolkit'

const selectDynamicPaperTutorial = (state: any) =>
  state.dynamicPaperOnboardingTutorialSlice

const dynamicPaperTutorialSelector = createDraftSafeSelector(
  selectDynamicPaperTutorial,
  (state: IDynamicPaperTutorialState) => state,
)

export default dynamicPaperTutorialSelector
